<div class="header-content">

  <!-- Left side icon and title -->
  <div class="left-side">    
    <a href="/">
      <img src="images/exploration-icon.png" alt="explore icon" />
      <span>eXplore acreage</span>
    </a>
  </div>

  <!-- nav links  -->
  <nav class="nav-links">
    <a routerLink="/tracking" routerLinkActive="active-link-text">tracking</a>
    <a routerLink="/reports" routerLinkActive="active-link-text">reports</a>
    <a routerLink="/admin" routerLinkActive="active-link-text">admin</a>
    <a routerLink="/about" routerLinkActive="active-link-text">about</a>
  </nav>


  <!-- right side support & feedback and avatar -->  
  <div class="right-side">
    
    <a href="https://go.chevron.com/exploration" target="_blank" rel="noopener noreferrer">support</a>
    <span> | </span>
    <a href="https://go.chevron.com/exploration" target="_blank" rel="noopener noreferrer">feedback</a>

    <!-- Show user pic if we have it, else show users initials -->
    <div class="avatar">
      @if (userPhotoUrl()) {
        <img class="avatar-img" [src]="userPhotoUrl()" alt="avatar" />      
      } @else {
        <span class="initials">{{ userInitials() }}</span>
      }
    </div>

  </div>

</div>
